/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Form from "./Form";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { post } from "../library/Api";
import { Link } from "react-router-dom";

async function onSubmit(values, setLoggedIn) {
  const data = {
    username: values.username,
    userpassword: values.password,
  };
  post("login", data).then(
    (response) => {
      if (response.status === 200) {
        const { access_token, first_name, company, company_name,admin_id } =
          response.data.data;
        localStorage.setItem(
          "MCData",
          JSON.stringify({
            token: access_token,
            first_name: first_name,
            company: company,
            companyid: company_name,
            admin_id:admin_id
          })
        );
        localStorage.setItem("company", response.data.data.company);
        localStorage.setItem("admin_id", response.data.data.admin_id);
        localStorage.setItem("loggedIn", true);
        toast.info(`Welcome back`, {
          autoClose: 1000,
          onClose: () => setLoggedIn(true),
        });
      } else {
        toast.error("Invalid username or password", {
          autoClose: 1000,
        });
      }
    },
    (error) => {
      toast.error("Failed Login", {
        autoClose: 3000,
      });
    }
  );
}

function LoginForm() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [reset, setReset] = useState(false);
  const [otp, setOtp] = useState(false);
  const [userName, setusername] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const getLoginData = (e) => {
    setusername(e.target.value);
  };
 
  const getLoginDataotp = (e) => {
    const regex = /^\d{1,6}$/;

    const input = e.target.value
    if (regex.test(input)) {
      setCode(input)
    }
    if(input == '') {
      setCode('')
    }
    // setCode(e.target.value);
  };

  const getLoginDatas = (e) => {
    const newpass = e.target.value
    const regex = /^\S{1,20}$/;
    if (regex.test(newpass)) {
      setPassword(newpass);
    }
    if(newpass == '') {
      setPassword(newpass);
    }
    
  };

  const getLoginDatasconfirm = (e) => {
  
    const confpass = e.target.value
    const regex = /^\S{1,20}$/;
    if (regex.test(confpass)) {
      setConfirmpassword(confpass);
    }
    if(confpass == '') {
      setConfirmpassword(confpass);
    }
  };

  const getReset = (e) => {
    setReset(true);
    setPassword('')
  };
  const insert = (e) => {
    setReset(false);
    e.preventDefault();
    const data = {
      username: userName,
      userpassword: password,
    };
    post("login", data).then(
      (response) => {
        if (response.status === 200) {
          console.log("log in data = ", response.data.data);
          const { access_token, first_name, company, company_name,admin_id } =
            response.data.data;
          localStorage.setItem(
            "MCData",
            JSON.stringify({
              token: access_token,
              first_name: first_name,
              company: company,
              companyid: company_name,
              admin_id:admin_id
            })
          );
          localStorage.setItem("company", response.data.data.company);
          localStorage.setItem("loggedIn", true);
          toast.info(`Welcome back`, {
            autoClose: 1000,
            onClose: () => setLoggedIn(true),
          });
        } else {
          toast.error("Invalid username or password", {
            autoClose: 1000,
          });
        }
      },
      (error) => {
        toast.error("Failed Login", {
          autoClose: 3000,
        });
      }
    );
  };
  const insertsotp = (e) => {
    setReset(false);
    e.preventDefault();
    const data = {
        email: userName,
        otp: code,
        new_password: password,
        confirm_password: confirmpassword,


    };
    post("verifyforgotpasswordotp", data)
        .then((response) => {
            // console.log("response", response);


            toast.success("OTP verification done Successfully", {
                autoClose: 500,
            });
           setOtp(false);
           setCode('')
           setPassword('')
           setConfirmpassword('')
            navigate(0);
            
        }, (error) => {
            toast.error(error.response.data.msg, {
                autoClose: 3000,
                
            });
            setCode('')
            setPassword('')
           setConfirmpassword('')
          
        }
        );

}

  const inserts = (e) => {
    
    e.preventDefault();

        post(`forgotpassword?email=${userName}`)
            .then((response) => {
                // console.log("response", response);

                setReset(false);
                toast.success("OTP was Send to the Email ID Successfully", {
                    autoClose: 500,
                });
                setOtp(true);


            }, (error) => {
                // console.log("response", error.response);

                toast.error(error.response.data.msg, {
                    autoClose: 3000,
                });

            }
            );
  };


  useEffect(() => {
    if (loggedIn) {
      navigate("/dashboard");
      window.location.reload();
    }
  }, [loggedIn, navigate]);

  return (
    <div
      className="d-flex align-items-center justify-content-center flex-column"
      style={{ height: "100vh" }}
    >
       <h2 className="text-center text-uppercase text-primary-color mb-4">
                  Credential Management
                </h2>
                <div className="position-relative login-box">
                <div class="bubble"></div>
      <div className="">
        {/* <Form template={template} onSubmit={(values) => onSubmit(values, setLoggedIn)} chooseMessage={chooseMessage} /> */}
        {reset === false && otp === false && (
          <>
            <form onSubmit={insert}>
              <div class="form-data">
                {/* <h2 className="text-center text-uppercase text-primary-color">
                  Credential Management
                </h2> */}
                <h3 className="text-blue text-center pb-2 mb-5" style={{color: '#1998f0'}}>Login</h3>
                <div class="forms-inputs position-relative mb-5">
                  <span for="email" style={{    position: 'absolute',
    top: '-14px',
    left: '15px',
    background: '#fff',
    padding: '1px 10px'}}>Email ID</span>
                  <input
                    type="email"
                    class="form-control"
                    id="username"
                    name="username"
                    placeholder=""
                    onChange={getLoginData}
                    required
                    style={{height: '50px',
                      border: '2px solid #eee',
                      width: '100%'}}
                  />
                </div>

                <div class="forms-inputs mb-2 mt-4  position-relative">
                  <span style={{    position: 'absolute',
    top: '-14px',
    left: '15px',
    background: '#fff',
    padding: '1px 10px'}}>Password</span>
                  <input
                    class="form-control"
                    id="password"
                    name="password"
                    placeholder=""
                    type="password"
                    onChange={getLoginDatas}
                    required
                    style={{height: '50px',
                    border: '2px solid #eee',
                    width: '100%'}}
                  />
                </div>
                <div class="float-right text-blue my-4 text-end">
                  <Link onClick={getReset}>Forgot Password?</Link>
                </div>
                <div className="w-100 text-center">
                  <button type="submit" className="btn btn-primary sign-btn">
                    Sign In
                  </button>
                </div>
              </div>
            </form>
          </>
        )}

        {reset === true && (
          <>
            <form
            onSubmit={inserts}
            >
              <div class="form-data">
                {/* <h2 className="text-center text-uppercase text-primary-color">
                  Credential Management
                </h2> */}
                <h3 className="text-blue text-center pb-2" style={{color: '#1998f0'}}>Reset</h3>
                <div class="forms-inputs position-relative">
                  <span for="email"  style={{    position: 'absolute',
    top: '-14px',
    left: '15px',
    background: '#fff',
    padding: '1px 10px'}}>Email ID</span>
                  <input
                    type="email"
                    class="form-control"
                    placeholder=""
                    autocomplete="new-password"
                    onChange={getLoginData}
                    required
                    style={{height: '50px',
                    border: '2px solid #eee',
                    width: '100%'}}
                  />
                </div>

                <div className="w-100 text-center mt-4">
                  <button type="submit" className="btn btn-primary sign-btn">
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </>
        )}
        {otp === true && (
          <>
            <div class="form-data">
            {/* <h2 className="text-center text-uppercase text-primary-color">
                  Credential Management   
                </h2> */}
              <h3 className="text-blue text-center pb-2" style={{color: '#1998f0'}}>Password Reset</h3>

              <div class="forms-inputs position-relative">
                <span  style={{    position: 'absolute',
    top: '-14px',
    left: '15px',
    background: '#fff',
    padding: '1px 10px'}}>New Password</span>
                <input
                  class="form-control"
                  id="password"
                  value={password}
                  name="password"
                  placeholder=""
                  type="password"
                  onChange={getLoginDatas}
                  required
                  autoComplete="new-password"
                  style={{height: '50px',
                  border: '2px solid #eee',
                  width: '100%'}}
                />
              </div>
              <div class="forms-inputs position-relative">
                <span  style={{    position: 'absolute',
    top: '-14px',
    left: '15px',
    background: '#fff',
    padding: '1px 10px'}}>Confirm Password</span>
                <input
                  class="form-control"
                  id="password"
                  name="password"
                  value={confirmpassword}
                  placeholder=""
                  type="password"
                  onChange={getLoginDatasconfirm}
                  required
                  autoComplete="new-password"
                  style={{height: '50px',
                  border: '2px solid #eee',
                  width: '100%'}}
                />
              </div>
              <div class="forms-inputs position-relative">
                <span  style={{    position: 'absolute',
    top: '-14px',
    left: '15px',
    background: '#fff',
    padding: '1px 10px'}}>OTP Code</span>
                <input
                  class="form-control"
                  id="username"
                  name="username"
                  placeholder=""
                  type="text"
                  value={code}
                  onChange={getLoginDataotp}
                  required
                  autoComplete="new-password"
                  style={{height: '50px',
                  border: '2px solid #eee',
                  width: '100%'}}
                />
              </div>
              
              <div class="w-100 text-center mt-4">
                <button
                  type="button"
                  class="btn btn-primary sign-btn"
                    onClick={insertsotp}
                >
                  Submit
                </button>
              </div>
            </div>
          </>
        )}
        <ToastContainer />
      </div>
      <div class="bubbleSmall"></div>
      </div>
    </div>
  );
}

export default LoginForm;
